var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#009CDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.99H14.0025V8H8V13.99ZM10.0008 9.99667H12.0017V12.0224H10.0008V9.99667ZM15.9975 8V13.99H22V8H15.9975ZM19.9992 11.9933H17.9983V9.99667H19.9992V11.9933ZM8 21.9709H14.0025V15.9867H8V21.9709ZM10.0008 17.9834H12.0017V19.9742H10.0008V17.9834ZM21.0025 15.9867H22V19.9742H19.0017V19.0079H17.9983V22H15.9975V15.9867H19.0017V16.9821H21.0025V15.9867ZM21.0025 20.9755H22V21.9709H21.0025V20.9755ZM19.0017 20.9755H19.9992V21.9709H19.0017V20.9755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueQr);
export default __webpack_public_path__ + "static/media/blue-qr.925a88ddc3830b048e0b83e07ea22752.svg";
export { ForwardRef as ReactComponent };